/**
 * DOM rendering of the NYL-approved report disclosure (WP-747) for the on-screen report pages.
 *
 * The wording comes from `getNylReportDisclosureParagraphs` in `@shared`, which the PDF report and
 * the comparison PDF render too. This component only turns those paragraphs into `<p>` elements, so
 * each page passes its own paragraph and link classes and keeps its look. It renders no wrapper or
 * title: the page's existing DISCLOSURES box stays in place and this fills it.
 */
import { Fragment } from 'react';
import { getNylReportDisclosureParagraphs } from '@shared';

interface NylReportDisclosureProps {
    clientName: string;
    paragraphClassName?: string;
    linkClassName?: string;
}

export function NylReportDisclosure({ clientName, paragraphClassName, linkClassName }: NylReportDisclosureProps) {
    return (
        <>
            {getNylReportDisclosureParagraphs(clientName).map((paragraph, paragraphIndex) => (
                <p key={paragraphIndex} className={paragraphClassName}>
                    {paragraph.map((segment, segmentIndex) =>
                        segment.type === 'link' ? (
                            <a
                                key={segmentIndex}
                                href={segment.url}
                                target="_blank"
                                rel="noreferrer"
                                className={linkClassName}
                            >
                                {segment.content}
                            </a>
                        ) : (
                            <Fragment key={segmentIndex}>{segment.content}</Fragment>
                        ),
                    )}
                </p>
            ))}
        </>
    );
}
